// admin.* — moderation operations performed in-room.
//
// MVP scope: kick only. Room rename, credential management, room deletion
// run over a separate HTTP admin API (architecture.md §18.0 / §18.7) and
// are intentionally not part of the WS protocol.
// (protocol-events.md §6)
import { z } from 'zod';
/** `admin.kick` — c→s. Sender must hold `Perm.KICK` (or be admin). */
export const adminKickSchema = z.object({
    t: z.literal('admin.kick'),
    targetUid: z.string(),
    /** Reason recorded in audit logs only; not broadcast. */
    reason: z.string().optional(),
});
/**
 * `admin.kick-ack` — s→c unicast back to the actor.
 *
 * The kicked user learns about it via `room.member-left` instead.
 * (protocol-events.md §6.2)
 */
export const adminKickAckSchema = z.object({
    t: z.literal('admin.kick-ack'),
    targetUid: z.string(),
});
/** `admin.kick-rejected` — s→c unicast on failure. */
export const adminKickRejectedSchema = z.object({
    t: z.literal('admin.kick-rejected'),
    targetUid: z.string(),
    reason: z.enum(['no-permission', 'target-not-found', 'cannot-kick-self', 'cannot-kick-admin']),
    message: z.string().optional(),
});
//# sourceMappingURL=admin.js.map